export const enum RoundingTypeCode {
    NONE = "NONE",
    DECIMAL_PLACES = "DP",
    SIGNIFICANT_FIGURES = "SF",
}
